<div viewEdit="initialState" #viewEdit="viewEdit">
    <div class="view view-edit-show">
        <div style="display:flex;flex-direction: row;">
            <h6 style="flex:2">
                Article
            </h6>
            <div style="flex:1;display:flex;justify-content:end">
                <nb-actions>
                    <nb-action icon="edit-outline" (click)="viewEdit.toggle()" title="Edit Article"></nb-action>
                </nb-actions>
            </div>
        </div>
        <div [innerHTML]="articleData"></div>
    </div>
    <div class="edit view-edit-hide">
        <h6>
            Edit Article
        </h6>
        <form [formGroup]="form">
            <!-- <label for="articleData">Article</label> -->
            <!-- <input nbInput fullWidth placeholder="Article" formControlName="articleData" /> -->
            <div>
                <ckeditor
                    formControlName="articleData"
                    id="articleData">
                </ckeditor>
            </div>
        </form>
        <div style="display:flex;flex-direction: row;padding: 0.5rem 1rem;">
            <span>&nbsp;</span>
            <div style="flex:1;display:flex;justify-content:end">
                <nb-actions>
                    <nb-action icon="close-outline" (click)="viewEdit.toggle()" title="Edit Article"></nb-action>
                    <nb-action icon="checkmark-outline" (click)="submit()" title="Submit Article"></nb-action>
                </nb-actions>
            </div>
        </div>
    </div>
</div>
